import type { AllocationEdgeDraft } from './executionDraftTypes';
import type { DeliveryGroupStopDraft } from './deliveryGroupTypes';
import { legacyDraftsToAllocationEdges } from './allocationEdgeDraft';

export type ItineraryCargoContext = {
  fromStopDraft?: Record<number, string | undefined>;
  toStopDraft?: Record<number, string | undefined>;
  quantityDraft?: Record<number, number>;
  selectedIds?: number[];
  allocationEdges?: AllocationEdgeDraft[];
};

export function resolveItineraryAllocationEdges(ctx?: ItineraryCargoContext): AllocationEdgeDraft[] {
  if (!ctx) return [];
  if (ctx.allocationEdges?.length) {
    return ctx.allocationEdges.filter((e) => Number(e.quantity) > 0);
  }
  const selectedIds = ctx.selectedIds ?? [];
  if (selectedIds.length === 0) return [];
  return legacyDraftsToAllocationEdges({
    selectedIds,
    fromStopDraft: ctx.fromStopDraft ?? {},
    toStopDraft: ctx.toStopDraft ?? {},
    quantityDraft: ctx.quantityDraft ?? {}
  });
}

/** Distinct cargo items linked to a stop (loading: from, unloading: to). */
export function countCargoItemsAtStop(
  stopUid: string,
  stopType: DeliveryGroupStopDraft['type'],
  edges: AllocationEdgeDraft[]
): number {
  const cargoIds = new Set<number>();
  for (const edge of edges) {
    if (stopType === 'loading' && edge.fromStopUid === stopUid) {
      cargoIds.add(Number(edge.cargoId));
    }
    if (stopType === 'unloading' && edge.toStopUid === stopUid) {
      cargoIds.add(Number(edge.cargoId));
    }
  }
  return cargoIds.size;
}
